
import { createTheme } from '@mui/material';
import { typography } from './typography';
import { card } from './card';
import defaultTheme from './default';

export default createTheme({ ...defaultTheme,...typography, ...card});